import React from 'react';
import styled from 'styled-components';
import useStore from '~/store';
import Checkbox from '~/components/Checkbox';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 12px;
`;

const selector = (s) => ({
  dynamicXAxis: s.dynamicXAxis,
  setDynamicXAxis: s.setDynamicXAxis,
});

export default function ModeSelect() {
  const { dynamicXAxis, setDynamicXAxis } = useStore(selector);

  return (
    <Wrapper>
      <Checkbox
        onChange={(evt) => setDynamicXAxis(evt.target.checked)}
        showValue={false}
        label="automatisch zoomen"
        checked={dynamicXAxis}
        style={{ fontSize: 12 }}
      />
    </Wrapper>
  );
}
